import React, { SVGProps } from "react";
import Icon from "./Icon/Icon";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgIcon = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M11.2 4.8c-.2-.2-.5-.2-.7 0L8 7.3 5.5 4.8c-.2-.2-.5-.2-.7 0s-.2.5 0 .7L7.3 8l-2.5 2.5c-.2.2-.2.5 0 .7.1.1.2.1.3.1s.3-.1.4-.1L8 8.7l2.5 2.5c.2.2.5.2.7 0s.2-.5 0-.7L8.7 8l2.5-2.5c.2-.2.2-.5 0-.7M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m0 15c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7" />
  </svg>
);
const SvgXCircle = (
  props: Omit<React.ComponentProps<typeof Icon>, "SvgIcon" | "name">
) => <Icon SvgIcon={SvgIcon} name="x-circle" {...props} />;
export default SvgXCircle;
